module.exports = __webpack_public_path__ + "img/brand-7.9081b77c.svg";